(function () {
  'use strict';
  const storageKey = 'q4_supporter_selections_v4';
  const memory = {};
  const text = JSON.parse(document.getElementById('QFundraiserText')?.textContent || '{}');
  const root = window.Shopify?.routes?.root || '/';
  function read(key) {
    if (memory[key]) return memory[key];
    for (const kind of ['localStorage', 'sessionStorage']) {
      try {
        const entry = JSON.parse(window[kind].getItem(storageKey) || '{}')[key];
        if (entry && typeof entry === 'object') return entry;
      } catch (_) {}
    }
    try {
      const cookie = document.cookie.split('; ').find(value => value.startsWith('q4_support_' + encodeURIComponent(key) + '='));
      if (cookie) return JSON.parse(decodeURIComponent(cookie.slice(cookie.indexOf('=') + 1)));
    } catch (_) {}
    return null;
  }
  function write(key, value) {
    memory[key] = value;
    for (const kind of ['localStorage', 'sessionStorage']) {
      try {
        const entries = JSON.parse(window[kind].getItem(storageKey) || '{}');
        entries[key] = value;
        window[kind].setItem(storageKey, JSON.stringify(entries));
      } catch (_) {}
    }
    try {
      document.cookie = 'q4_support_' + encodeURIComponent(key) + '=' + encodeURIComponent(JSON.stringify(value)) + '; Path=/; Max-Age=2592000; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
    } catch (_) {}
  }
  function collectionUrl(key) { return root + 'collections/' + encodeURIComponent(key); }
  function option(select, label, value = label) { select.add(new Option(label, value)); }
  function updateLinks(key, selection) {
    document.querySelectorAll('[data-product-grid]').forEach(grid => {
      if (grid.dataset.fundraiserKey !== key) return;
      grid.querySelectorAll('a[href*="/products/"]').forEach(link => {
        const url = new URL(link.href);
        url.searchParams.set('fundraiser', key);
        url.searchParams.set('attribution', selection.attribution);
        url.searchParams.set('q4_player', selection.participant || '');
        url.searchParams.set('q4_required', selection.required ? '1' : '0');
        url.searchParams.set('q4_general', selection.generalLabel || text.general_fund);
        link.href = url.href;
      });
    });
  }
  function initCollections() {
    const selectors = new Map();
    document.querySelectorAll('[data-participant-selector]').forEach(box => {
      const key = box.dataset.fundraiserKey;
      const select = box.querySelector('[data-q-participant-select]');
      if (!key || !select) return;
      selectors.set(key, box);
      if (box.dataset.qInitialized) return;
      box.dataset.qInitialized = 'true';
      const status = box.querySelector('[data-q-participant-status]');
      const button = box.querySelector('[data-q-save-participant]');
      const required = box.dataset.required === 'true';
      const generalLabel = box.dataset.generalLabel || text.general_fund;
      const roster = [...new Set((select.dataset.participants || '').split(/\r?\n|\|/).map(value => value.trim()).filter(Boolean))];
      select.options.length = 1;
      roster.forEach(name => option(select, name));
      if (box.dataset.includeGeneral === 'true') option(select, generalLabel);
      const previous = read(key);
      if (previous && [...select.options].some(item => item.value === previous.participant)) select.value = previous.participant;
      function persist() {
        const selection = { participant: select.value || (required ? '' : generalLabel), fundraiser: box.dataset.fundraiser, attribution: 'participant', required, generalLabel, collectionUrl: collectionUrl(key) };
        write(key, selection);
        updateLinks(key, selection);
        if (status) status.textContent = selection.participant ? text.saved + ' ' + selection.participant : text.choose_player;
        return selection;
      }
      select.addEventListener('change', persist);
      button?.addEventListener('click', () => {
        const selection = persist();
        if (required && !selection.participant) { select.focus(); return; }
        document.getElementById('FundraiserProducts')?.scrollIntoView({behavior:'smooth', block:'start'});
      });
      box.qPersist = persist;
      persist();
    });
    document.querySelectorAll('[data-product-grid]').forEach(grid => {
      const key = grid.dataset.fundraiserKey;
      if (!key) return;
      const selector = selectors.get(key);
      if (selector) { selector.qPersist?.(); return; }
      const selection = { fundraiser: grid.dataset.fundraiser, participant: text.general_fund, attribution: 'general', required: false, generalLabel: text.general_fund, collectionUrl: collectionUrl(key) };
      write(key, selection);
      updateLinks(key, selection);
    });
  }
  function initProduct(product) {
    if (product.dataset.qInitialized) return;
    product.dataset.qInitialized = 'true';
    const form = product.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    const params = new URLSearchParams(location.search);
    const all = JSON.parse(product.querySelector('[data-q-product-collections]')?.textContent || '[]');
    const campaigns = all.filter(item => !['all', 'frontpage'].includes(item.key));
    const explicit = params.get('fundraiser') || product.dataset.collectionKey;
    let campaign = campaigns.find(item => item.key === explicit);
    if (!campaign && campaigns.length === 1) campaign = campaigns[0];
    const picker = form.querySelector('[data-q-fundraiser-picker]');
    const choice = form.querySelector('[data-q-fundraiser-choice]');
    const error = form.querySelector('[data-q-attribution-error]');
    const fi = form.querySelector('[name="properties[Fundraiser]"]');
    const pi = form.querySelector('[name="properties[Participant]"]');
    const support = form.querySelector('#QProductSupporting');
    const supporting = form.querySelector('#QSupportingName');
    const change = form.querySelector('#QChangeSupporter');
    let selection;
    function setCampaign() {
      if (!campaign) { selection = null; return; }
      const saved = read(campaign.key);
      const fromLink = explicit === campaign.key && params.has('attribution');
      const mode = fromLink ? params.get('attribution') : (saved?.attribution || (['spartans','participant'].includes(campaign.template) || campaign.key === 'spartans' ? 'participant' : 'general'));
      const required = fromLink ? params.get('q4_required') === '1' : Boolean(saved?.required);
      const generalLabel = (fromLink && params.get('q4_general')) || saved?.generalLabel || text.general_fund;
      const player = fromLink && params.has('q4_player') ? params.get('q4_player') : saved?.participant;
      selection = { fundraiser: campaign.name, attribution: mode, participant: mode === 'participant' ? (player || (required ? '' : generalLabel)) : generalLabel, required, generalLabel, collectionUrl: campaign.url };
      write(campaign.key, selection);
    }
    function apply() {
      fi.disabled = !campaign;
      pi.disabled = !campaign;
      fi.value = campaign?.name || '';
      pi.value = selection?.participant || '';
      if (support) support.hidden = !campaign;
      if (supporting) supporting.textContent = selection?.participant || text.choose_player;
      if (change) { change.hidden = !campaign || selection?.attribution !== 'participant'; change.href = (campaign?.url || '#') + '#ChooseSupporter'; }
      if (error) error.hidden = Boolean(campaign) || !campaigns.length;
    }
    if (!campaign && campaigns.length > 1 && choice) {
      picker.hidden = false;
      choice.disabled = false;
      choice.required = true;
      option(choice, text.choose_fundraiser, '');
      campaigns.forEach(item => option(choice, item.name, item.key));
      choice.addEventListener('change', () => { campaign = campaigns.find(item => item.key === choice.value); setCampaign(); apply(); });
    }
    setCampaign();
    apply();
    form.addEventListener('submit', event => {
      apply();
      if ((!campaign && campaigns.length) || (selection?.required && !selection.participant)) {
        event.preventDefault();
        if (error) { error.hidden = false; error.textContent = campaign ? text.choose_player : text.choose_fundraiser; }
        if (campaign) location.href = campaign.url + '#ChooseSupporter';
        else choice?.focus();
      }
    }, true);
    form.addEventListener('formdata', event => {
      if (!campaign) return;
      event.formData.set('properties[Fundraiser]', campaign.name);
      event.formData.set('properties[Participant]', selection.participant);
    });
  }
  function init() { initCollections(); document.querySelectorAll('[data-product-fundraiser]').forEach(initProduct); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => setTimeout(initCollections, 0));
  window.addEventListener('pageshow', initCollections);
})();

(function () {
  'use strict';
  function initCarts() {
    document.querySelectorAll('[data-q-cart-form]').forEach(form => {
      if (form.dataset.qCartInitialized) return;
      form.dataset.qCartInitialized = 'true';
      let busy = false;
      const error = form.querySelector('[data-q-cart-error]');
      async function update(url, payload) {
        if (busy) return;
        busy = true;
        error.hidden = true;
        form.setAttribute('aria-busy', 'true');
        const controls = [...form.querySelectorAll('button, input')].map(control => [control, control.disabled]);
        controls.forEach(([control]) => { control.disabled = true; });
        try {
          const response = await fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {'Content-Type':'application/json', 'Accept':'application/json'},
            body: JSON.stringify(payload)
          });
          const cart = await response.json();
          if (!response.ok || !Array.isArray(cart.items)) throw new Error(form.dataset.errorMessage);
          document.querySelectorAll('[data-q-cart-count]').forEach(count => { count.textContent = cart.item_count; });
          window.location.assign(form.dataset.cartUrl);
        } catch (_) {
          error.textContent = form.dataset.errorMessage;
          error.hidden = false;
          controls.forEach(([control, disabled]) => { control.disabled = disabled; });
          form.removeAttribute('aria-busy');
          busy = false;
        }
      }
      form.addEventListener('submit', event => {
        if (busy) { event.preventDefault(); return; }
        if (event.submitter?.name === 'checkout') return;
        event.preventDefault();
        if (!form.reportValidity()) return;
        const updates = {};
        form.querySelectorAll('[data-q-line-key]').forEach(input => { updates[input.dataset.qLineKey] = Number(input.value); });
        update(form.dataset.updateUrl, {updates});
      });
      form.addEventListener('click', event => {
        const link = event.target.closest('[data-q-remove-key]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        update(form.dataset.changeUrl, {id:link.dataset.qRemoveKey, quantity:0});
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCarts); else initCarts();
  document.addEventListener('shopify:section:load', initCarts);
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    const link = document.querySelector('[data-q-cart-link]');
    if (!link) return;
    fetch(link.dataset.cartJson, {credentials:'same-origin', cache:'no-store'})
      .then(response => { if (!response.ok) throw new Error(); return response.json(); })
      .then(cart => { document.querySelectorAll('[data-q-cart-count]').forEach(count => { count.textContent = cart.item_count; }); })
      .catch(() => {});
  });
})();
